'use client'

import { memo } from 'react'
import clsx from 'clsx'

import {
  DeliverySlotsByTimeOfTheDay,
  TMSDeliverySlotsArraySlot
} from 'modules/delivery'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import { DeliverySlot } from './DeliverySlot'

import styles from './DeliverySlotSection.module.scss'

// Types

export type DeliverySlotSectionProps = {
  title: string
  slots: TMSDeliverySlotsArraySlot[] | undefined
  emptySlots: TMSDeliverySlotsArraySlot[] | undefined
  deliverySlots: DeliverySlotsByTimeOfTheDay | null
  selectedDeliverySlots: TMSDeliverySlotsArraySlot[]
  hoverPreviewSlots: {
    slots: TMSDeliverySlotsArraySlot[]
    action: 'add' | 'remove'
  } | null
  setHoverPreviewSlots: React.Dispatch<
    React.SetStateAction<{
      slots: TMSDeliverySlotsArraySlot[]
      action: 'add' | 'remove'
    } | null>
  >
  handleChangeDeliverySlot: (
    value: boolean,
    slot?: TMSDeliverySlotsArraySlot
  ) => void
  getAffectedSlotsCallback: (
    slot: TMSDeliverySlotsArraySlot,
    action: 'add' | 'remove'
  ) => TMSDeliverySlotsArraySlot[]
}

export const DeliverySlotTimeOfTheDayTitle = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h3 {...props} className={clsx(styles.title, className)} />
)

export const DeliverySlotSection = memo(
  ({
    title,
    slots,
    emptySlots,
    deliverySlots,
    selectedDeliverySlots,
    hoverPreviewSlots,
    setHoverPreviewSlots,
    handleChangeDeliverySlot,
    getAffectedSlotsCallback
  }: DeliverySlotSectionProps) => (
    <div data-section-title={title}>
      <DeliverySlotTimeOfTheDayTitle>{title}</DeliverySlotTimeOfTheDayTitle>
      <ul className={styles.list}>
        {isNotNilOrEmpty(emptySlots) ? (
          emptySlots?.map(slot => (
            <DeliverySlot
              key={slot.date + slot.time}
              time={slot.time}
              value={selectedDeliverySlots.some(
                selectedSlot => selectedSlot.time === slot.time
              )}
              slot={
                deliverySlots && slots
                  ? slots.find(deliverySlot => deliverySlot.time === slot.time)
                  : undefined
              }
              onChange={(_, value) => {
                handleChangeDeliverySlot(value, slot)
              }}
              selectedSlots={selectedDeliverySlots}
              hoverPreviewSlots={hoverPreviewSlots}
              setHoverPreviewSlots={setHoverPreviewSlots}
              shownAffectedSlots={getAffectedSlotsCallback}
            />
          ))
        ) : (
          <li className={styles.item}>Brak dostępnych terminów</li>
        )}
      </ul>
    </div>
  )
)

DeliverySlotSection.displayName = 'DeliverySlotSection'
